import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { GameContent } from './components/gameContent/GameContent';

import './App.css';

function App() {
  return (
    <Routes>
      <Route exact path='dragonsforce' element={<GameContent/>} />
      <Route exact path='*' element={<Navigate to='dragonsforce'/> } />
    </Routes>
  );
}

export default App;
